import { render } from "./ImpulsePopup.vue?vue&type=template&id=5a14333a&scoped=true"
import script from "./ImpulsePopup.vue?vue&type=script&lang=js"
export * from "./ImpulsePopup.vue?vue&type=script&lang=js"

import "./ImpulsePopup.vue?vue&type=style&index=0&id=5a14333a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a14333a"]])

export default __exports__